import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

// Components
import { ProgressBar } from '../ProgressBar'
import Text from '../Text'
import { IconText } from '../rituals/Atoms'

// Utils
import { useAppState } from '../../context/AppContext'

// Types
import { EvaluationAssessmentType } from '../../common/models/Evaluation'

interface AssessmentsProgressProps {
  total: number
  percentage: number
  average: number
  variant: EvaluationAssessmentType
}

const AssessmentsProgress: React.FC<AssessmentsProgressProps> = ({
  total,
  percentage,
  average,
  variant,
}) => {
  const appState = useAppState()
  const { theme } = appState
  const { t } = useTranslation()

  const getVariantTranslation = (v: EvaluationAssessmentType) =>
    v === 'culture'
      ? t('general.feedback.culture')
      : v === 'skills'
      ? t('general.skills')
      : t('general.goals.goals')

  return (
    <div>
      <HeaderRow>
        <Text textStyle="labelSmallCaps" textAlign="left">
          {t('assessmentProgress.assessments', {
            type: getVariantTranslation(variant).toLowerCase(),
          })}
        </Text>
        <Text textStyle="caption" textAlign="right">
          {`${total} ${t('assessmentProgress.total')}`}
        </Text>
      </HeaderRow>
      <StyledProgressBar
        color={theme.colors.primary}
        backgroundColor={theme.colors.primaryFadeLight}
        percentage={percentage}
      />
      <IconText
        icon="User"
        texts={[
          {
            text: getVariantTranslation(variant),
            color: 'primary',
          },
          {
            text: t('assessmentProgress.assessedBy', {
              count: variant === 'culture' ? 1 : 2,
            }),
          },
          {
            text: average.toString(),
            color: 'primary',
          },
          {
            text: t('assessmentProgress.peopleOnAverage'),
          },
        ]}
      />
    </div>
  )
}

export default AssessmentsProgress

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledProgressBar = styled(ProgressBar)`
  margin: 4px 0;
  height: 16px;
  padding: 3px;

  & > div {
    height: 10px;
  }
`
